import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "771ffjpK2ZLL533Ea1l15Of", "GameCtr", undefined);

import { log, sys, Button, EditBox, Vec3, v3, PhysicsSystem, tween, Tween } from "cc";
import { Ball } from "../../Ball";
import { ItemAutoRecyle } from "../../itemAutoRecyle";
import { E_GameMode, E_GameState, E_PlatformType } from "../EnumBase";
import { App } from "./App";
import { E_SoundType } from "./SoundManager";

var GameCtr = /*#__PURE__*/function () {
  function GameCtr() {
    _defineProperty(this, "platformType", E_PlatformType.Normal);

    _defineProperty(this, "gameState", E_GameState.PreBegin);

    _defineProperty(this, "isSwitch", false);

    _defineProperty(this, "n_gameUI", null);

    _defineProperty(this, "n_gameScene", null);

    _defineProperty(this, "cam_ui", null);

    _defineProperty(this, "cam_game", null);

    _defineProperty(this, "cam_bg", null);

    _defineProperty(this, "n_link", null);

    _defineProperty(this, "n_bg", null);

    _defineProperty(this, "n_coinRoot", null);

    _defineProperty(this, "n_tokenRoot", null);

    _defineProperty(this, "n_msgRoot", null);

    _defineProperty(this, "n_guideLine", null);

    _defineProperty(this, "n_winTip", null);

    _defineProperty(this, "ball_game", null);

    _defineProperty(this, "n_drawPanel", null);

    _defineProperty(this, "n_psBallDie", null);

    _defineProperty(this, "lbl_score", null);

    _defineProperty(this, "line_game", null);

    _defineProperty(this, "line_draw", null);

    _defineProperty(this, "gameMode", E_GameMode.Time);

    _defineProperty(this, "pos_cur", []);

    _defineProperty(this, "pos_game", []);

    _defineProperty(this, "isLineDirty", false);

    _defineProperty(this, "isLineAngleZero", false);

    _defineProperty(this, "isBallStayingLine", false);

    _defineProperty(this, "isFristTouchLineAndBall", true);

    _defineProperty(this, "isWin", false);

    _defineProperty(this, "v_ballPre", v3(0, 0, 0));

    _defineProperty(this, "score", 0);

    _defineProperty(this, "t_run", 0);

    _defineProperty(this, "gameTims", 0);

    _defineProperty(this, "isAdOk_gameMonetize", false);

    _defineProperty(this, "time_ad", new Map());
  }

  var _proto = GameCtr.prototype;

  _proto.reset = function reset() {
    App.MapCtr.init();
    this.cam_game.node.position = v3(0, 0, 20);
    this.isFristTouchLineAndBall = true;
    this.n_winTip.active = false;
    App.DataMgr.calcGameCamSize();
    PhysicsSystem.instance.enable = false;
    var aimLen = 300 + App.DataMgr.tollgateLv * 50;
    if (aimLen > 2000) aimLen = 2000;
    App.DataMgr.mapLen = aimLen;
    this.score = 0;
    this.t_run = 0;
    this.isWin = false;
    this.v_ballPre = v3(0, 0, 0);
    this.ball_game.setPosition(v3(0, 5, 0));
    this.ball_game.active = true;
    this.ball_game.getComponent(Ball).init();
    this.n_guideLine.active = true;
    this.n_bg.setPosition(v3(0, 0, -20));
    this.cam_game.node.setPosition(v3(0, 0, 20));
    this.cam_bg.node.setPosition(v3(0, 0, 20));
    this.actball(true);
  };

  _proto.actball = function actball(isAct) {
    if (isAct) {
      tween(this.ball_game).repeatForever(tween().to(0.3, {
        scale: v3(1.2, 1.2, 1.2)
      }).to(0.3, {
        scale: v3(1, 1, 1)
      })).start();
    } else {
      Tween.stopAllByTarget(this.ball_game);
      this.ball_game.scale = v3(1, 1, 1);
    }
  };

  _proto.addAutoRecyle = function addAutoRecyle(n_cur) {
    if (!n_cur.getComponent(ItemAutoRecyle)) {
      n_cur.addComponent(ItemAutoRecyle);
    }
  }
  /**
   * 添加点击事件(toggle btn 都可收到回调)
   * @param n_root 根节点
   * @param btnCall 点击回调
   */
  ;

  _proto.addBtnEvent = function addBtnEvent(n_root, btnCall) {
    var allBtns = n_root.getComponentsInChildren(Button);
    var checkArr = [];

    for (var i = 0; i < allBtns.length; i++) {
      if (!allBtns[i].enabled) continue;

      if (checkArr.indexOf(allBtns[i].node.name) != -1) {
        continue;
      }

      allBtns[i].node.on(Button.EventType.CLICK, btnCall, this);
    }
  }
  /**添加点击事件 */
  ;

  _proto.addEBEvent = function addEBEvent(n_root, btnCall) {
    var allEBs = n_root.getComponentsInChildren(EditBox);

    for (var i = 0; i < allEBs.length; i++) {
      allEBs[i].node.on(EditBox.EventType.EDITING_DID_ENDED, btnCall, this);
    }
  }
  /**切换界面分组 */
  ;

  _proto.switchGrounp = function switchGrounp(n_cur, group) {
    for (var i = 0; i < n_cur.children.length; i++) {
      if (n_cur.children[i].children.length > 0) {
        this.switchGrounp(n_cur.children[i], group);
      } else {
        n_cur.children[i].layer = group;
      }
    }

    n_cur.layer = group;
  }
  /**检测游戏结束 */
  ;

  _proto.checkGameEnd = function checkGameEnd() {}
  /**飞 - 动画 */
  ;

  _proto.flyAmn = function flyAmn(pfbName, pos_from, pos_end, numF) {
    if (numF === void 0) {
      numF = 6;
    }

    var num = numF;
    var n_p = App.GameCtrl.n_msgRoot;
    var p_from = v3();
    Vec3.subtract(p_from, pos_from, n_p.worldPosition);
    var p_end = v3();
    Vec3.subtract(p_end, pos_end, n_p.worldPosition);
    var dt = 0.1;

    for (var i = 0; i < num; i++) {
      var n_cur = App.PoolMgr.getItem(pfbName);
      n_cur.parent = n_p; // this.switchGrounp(n_cur, E_LayerGroup.UI_Static);

      if (n_cur) {
        this.actFlyAmn(n_cur, p_from, p_end, dt * i);
      }
    }
  }
  /**单个飞行动作 */
  ;

  _proto.actFlyAmn = function actFlyAmn(n_cur, pos_from, pso_end, dt) {
    n_cur.scale = v3(1, 1, 1);
    n_cur.setPosition(pos_from);
    tween(n_cur).delay(dt).call(function () {
      App.SoundMgr.playEffectType(E_SoundType.CoinGain0);
    }).to(0.3, {
      position: pso_end,
      scale: v3(0.5, 0.5, 1)
    }).call(function () {
      App.SoundMgr.playEffectType(E_SoundType.CoinGain1);
      App.PoolMgr.returnItem(n_cur);
    }).start();
  }
  /**设置渲染最高层 */
  ;

  _proto.toMaxIndex = function toMaxIndex(n_cur) {
    var siblings = n_cur.parent && n_cur.parent.children;

    if (siblings) {
      siblings.sort(function (a, b) {
        return a.getSiblingIndex() - b.getSiblingIndex();
      });
    }
  };

  _proto.checkFromURL = function checkFromURL() {
    var refer = window.location.href;
    var allURL = [// "gamemone",
    // "gamedistri",
    // "fillgame",
    // "dob5",
    // "gguunn",
    // "kuzgame",
    // "hhtap",
    // "4399",
    // "localhost"
    //"fvplay"
    "ZmlsbGdhbWU=", "ZG9iNQ==", "Z2d1dW5u", "a3V6Z2FtZQ==", "aGh0YXA=", "NDM5OQ==", "bG9jYWxob3N0", "Z2FtZWRpc3RyaWJ1dGlvbg==", "ZnZwbGF5", "Z2FtZW1vbmV0aXpl"];
    var aimURLArr = [];

    for (var i = 0; i < allURL.length; i++) {
      var str_1 = window.atob(allURL[i]);
      aimURLArr.push(str_1);
    }

    var isOwn = false;

    for (var _i = 0; _i < aimURLArr.length; _i++) {
      if (refer.indexOf(aimURLArr[_i]) != -1) {
        isOwn = true;
        break;
      }
    }

    return isOwn;
  }
  /**
   * 是否支持振动
   */
  ;

  _proto.checkShake = function checkShake() {
    if (sys.isBrowser) {
      if (sys.isMobile && window.navigator && window.navigator.vibrate) {
        log("platform = browse");
        return true;
      }

      return false;
    } else if (sys.os == sys.OS.ANDROID) {
      log("platform = android");
      return true;
    }

    return false;
  };

  _proto.vibrate = function vibrate(t) {
    if (t === void 0) {
      t = 40;
    }

    log("...is can vibrate = ", App.DataMgr.isShake, sys.os, sys.OS.ANDROID, sys.isMobile); // if (!App.DataMgr.isShake) return;

    if (sys.isBrowser) {
      if (window.navigator && window.navigator.vibrate) {
        window.navigator.vibrate(t);
      }
    } else if (sys.os == sys.OS.ANDROID) {
      log("..android...vibrate...");
      this.callJava_ad("vibrate", "(I)V", [t]);
    }
  }
  /**
  * 调用java函数
  * @param func 调用目标函数名字
  * @param paramType 参数类型
  * @param param 参数列表
  */
  ;

  _proto.callJava = function callJava(func, paramType, param) {
    if (param === void 0) {
      param = [];
    }

    log(paramType + "   --callJava--  param: ", param);

    if (sys.isNative) {
      var _jsb$reflection;

      return (_jsb$reflection = jsb.reflection).callStaticMethod.apply(_jsb$reflection, ["com/cocos/game/UMeng", func, paramType].concat(param));
    } else {
      log.apply(void 0, [func, paramType].concat(param));
    }
  };

  _proto.callJava_ad = function callJava_ad(func, paramType, param) {
    if (param === void 0) {
      param = [];
    }

    log(paramType + "   --callJava--  param: ", param);

    if (sys.isNative) {
      var _jsb$reflection2;

      return (_jsb$reflection2 = jsb.reflection).callStaticMethod.apply(_jsb$reflection2, ["com/cocos/game/FIAds", func, paramType].concat(param));
    } else {
      log.apply(void 0, [func, paramType].concat(param));
    }
  };

  _proto.isJSBAd = function isJSBAd() {
    return sys.isNative && (this.platformType == E_PlatformType.TT || this.platformType == E_PlatformType.GoogleADM);
  };

  _createClass(GameCtr, null, [{
    key: "I",
    get: function get() {
      if (!GameCtr._I) {
        GameCtr._I = new GameCtr();
      }

      return GameCtr._I;
    }
    /**
     * 数据
     */

    /**平台类型 */

  }]);

  return GameCtr;
}();

_defineProperty(GameCtr, "_I", null);

export { GameCtr as default };

_cclegacy._RF.pop();